import Accordion, {AccordionProps} from '@mui/material/Accordion';
import AccordionActions, {AccordionActionsProps} from '@mui/material/AccordionActions';
import AccordionDetails, {AccordionDetailsProps} from '@mui/material/AccordionDetails';
import AccordionSummary, {AccordionSummaryProps} from '@mui/material/AccordionSummary';

import {styled} from '@mui/material/styles';

export const CAccordion = styled(Accordion)<AccordionProps>(
  (/* { theme } */) => ({
  }),
);

export const CAccordionActions = styled(AccordionActions)<AccordionActionsProps>(
  (/* { theme } */) => ({
  }),
);

export const CAccordionDetails = styled(AccordionDetails)<AccordionDetailsProps>(
  (/* { theme } */) => ({
  }),
);


export const CAccordionSummary = styled(AccordionSummary)<AccordionSummaryProps>(
  (/* { theme } */) => ({
  }),
);
